import {
  ListContractCreditPoolsResponseSchema,
  type ListContractCreditPoolsResponse,
} from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useContractCreditPoolsList(
  contractId: string,
  options?: CustomBaseUseQueryOptions<ListContractCreditPoolsResponse>,
) {
  return useQuery(
    queryKeys.contractCreditPools(contractId),
    async () => {
      const api = getPrivateApi();
      const listContractCreditPoolsResponse = await api.listContractCreditPools({ contractId });

      return ListContractCreditPoolsResponseSchema.parse(listContractCreditPoolsResponse);
    },
    { suspense: true, ...options },
  );
}
